import { type FC } from 'react';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';
import { Button, Group, Stack } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { createPayoutCascadeTemplateUrl, type PayoutCascadeTemplate } from '~/entities/payout';
import { CascadeTemplatesFilter } from './components/CascadeTemplatesFilter';
import { CascadeTemplatesList } from './components/CascadeTemplatesList';
import { $cascadeTemplatesFilter, paginationModel } from './model';

export const CascadeTemplates: FC = () => {
    const filter = useUnit($cascadeTemplatesFilter);
    const navigate = useNavigate();

    const handleRowClick = (template: PayoutCascadeTemplate) => {
        if (template.id?.value) {
            navigate(createPayoutCascadeTemplateUrl(template.id.value));
        }
    };

    return (
        <Stack gap='sm'>
            <Group justify='space-between'>
                <CascadeTemplatesFilter />

                <Button
                    leftSection={<IconPlus size={16} />}
                    onClick={() => navigate(createPayoutCascadeTemplateUrl())}
                >
                    Создать шаблон
                </Button>
            </Group>

            <CascadeTemplatesList
                filter={filter}
                paginationModel={paginationModel}
                onClick={handleRowClick}
            />
        </Stack>
    );
};
